import { GENDERS_ACTIONS } from 'constants/Actions/Genders';

// Estado inicial del reducer
const aInitialState = {
    aGenders: [],
    aGendersList: [],
    oGender: null,

    bIsSuccess: false,
    bIsError: false,
}
/**
 * Reducer que será utilizado para controlar los datos referidos a los generos almacenados en el sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const GenderReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case GENDERS_ACTIONS.GET:
            return { ...aState, aGenders: oAction.data };
        case GENDERS_ACTIONS.GET_LIST:
            return { ...aState, aGendersList: oAction.data };
        case GENDERS_ACTIONS.FIND:
            return { ...aState, oGender: oAction.data };
        case GENDERS_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case GENDERS_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case GENDERS_ACTIONS.CLEAN:
            return { ...aState, bIsSuccess: false, bIsError: false, oGender: null };
        default:
            return aState;
    }
}
